export interface IVideoPlayerWidgetState {
    minCookieLevel: number,
    disabled: boolean,
    image: string,
    videoActive: boolean,
    player: any
}

export default class VideoPlayerWidgetState implements IVideoPlayerWidgetState {
    minCookieLevel = 4;
    disabled = true;
    image = '';
    player: any;
    videoActive = false;
}
